import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  actionChangeLayerField,
  actionUpdateConfig,
  actionUpdateConfigWithChange,
} from "../../../../redux/action/layerConfig";
import { useAppSelector } from "../../../../redux/hooks";
import {
  HttpState,
  LayerName,
  MainConfigResponseBody,
} from "../../../../util/model";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";

import "./SideBar.scss";
import SideBarLayer from "./sidebar-layer/SideBarLayer";
import { RestApi } from "../../../../services/restapi.service";
import SNStatus from "./snstatus/SNStatus";
import CameraSettings from "./camera-settings/CameraSettings";

type SelectedLayerType = LayerName | "None";

interface Props {
    width: number;
}

export default React.memo(function SideBar(props: Props) {
  const [selectedLayer, setSelectedLayer] = useState<SelectedLayerType>("None");
  const [initRequest, setInitRequest] = useState<boolean>(true);

  const onSelectChange = (key: LayerName, checked: boolean) => {
    setSelectedLayer(key);
  };

  const dispatch = useDispatch();

  var layerConfig = useAppSelector((state) => state.layerConfig);
  const layerData = useAppSelector((state) => state.layerData);
  const saveConfigState = useAppSelector((state) => state.http.saveConfig);

  const onFieldChange = async (
    key: LayerName,
    fieldKey: string,
    fieldValue: any
  ) => {
    dispatch(
      actionUpdateConfigWithChange(
        key,
        fieldKey,
        fieldValue,
        layerConfig
      ) as any
    );
  };

  const onSaveConfig = () => {
    dispatch(actionUpdateConfig(layerConfig) as any);
  };
  console.log("dddd - ", layerConfig.CameraSettings);
  
  function FullBar() {
      return (
      <div className="SideBar">
      <div>
      <SNStatus
        width={props.width}
        config={layerConfig.CameraSettings}
        onCurrentCameraChange={(val) =>
          onFieldChange("CameraSettings", "CurrentCamera", val)
        }
      />
      </div>
      <div>
      <SideBarLayer
        name="Camera Settings"
        selected={selectedLayer === "CameraSettings"}
        onSelectedChange={(b) => onSelectChange("CameraSettings", b)}
      />
      <CameraSettings
        config={layerConfig.CameraSettings}
        onCurrentCameraChange={(val) =>
          onFieldChange("CameraSettings", "CurrentCamera", val) 
        }
        onCamerasChange={(val) =>
          onFieldChange("CameraSettings", "Cameras", val)
        }
      />
      {saveConfigState === HttpState.Failure && (
        <FormHelperText error={true}>Save Error</FormHelperText>
      )}
      </div>
      </div>
  )}
  
  function ShortBar() {
      return (
      <div className="SideBar">
      <SNStatus
        width={props.width}
        config={layerConfig.CameraSettings}
        onCurrentCameraChange={(val) =>
          onFieldChange("CameraSettings", "CurrentCamera", val)
        }
      />
      </div>  
  )}
  
  if(props.width > 1000) {
        return (FullBar())
    } else {
        return (ShortBar())
    }
});
